import React from 'react'
import styled from '@emotion/styled'

export const QuantidadeVagas = ({
  quantidadeOcupada,
  quantidadeTotal,
  ...props
}: { quantidadeOcupada: number; quantidadeTotal: number } & any) => {
  const {
    Layout,
    TextSemiBold,
    ContainerIndicadorVisual,
    ProgressoIndicadorVisual,
    VagasPreenchidas,
    getColor,
  } = QuantidadeVagas
  const percent = (quantidadeOcupada / quantidadeTotal) * 100
  const color = getColor(percent)
  const quantidadeDisponiveis = quantidadeTotal - quantidadeOcupada
  const textoVagasDisponiveis =
    quantidadeDisponiveis === 1 ? 'vaga disponível' : 'vagas disponíveis'
  return (
    <Layout {...props}>
      <TextSemiBold>
        {' '}
        Restam {quantidadeDisponiveis} {textoVagasDisponiveis}
      </TextSemiBold>
      <ContainerIndicadorVisual>
        <ProgressoIndicadorVisual style={{ width: percent + '%' }} color={color} />
      </ContainerIndicadorVisual>
      <VagasPreenchidas>
        Total de vagas: &nbsp; {quantidadeOcupada} / {quantidadeTotal}
      </VagasPreenchidas>
    </Layout>
  )
}
QuantidadeVagas.getColor = (percent: number) => {
  if (percent <= 80) return '#FBBA3E'
  if (percent > 80) return ' #E75656'
}
QuantidadeVagas.Layout = styled.div`
  text-align: left;
  max-width: 350px;
  @media (max-width: 768px) {
    width: 100%;
  }
`
QuantidadeVagas.ContainerIndicadorVisual = styled.div`
  width: 100%;
  height: 12px;
  background: #e1e1e1;
  display: block;
  padding: 0px;
  border-radius: 8px;
  margin-top: 6px;
  margin-bottom: 4px;
`
QuantidadeVagas.ProgressoIndicadorVisual = styled.div(
  (props) => `
  background: ${props.color};
  height: 100%;
  min-width: 12px;
  border-radius: 6px;
`
)
QuantidadeVagas.VagasPreenchidas = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #898989;
`

QuantidadeVagas.TextSemiBold = styled.h3`
  color: #898989;
  font-size: 14px;
  font-weight: 600;
`
